import React, {useState, useEffect} from 'react';
import { Modal, Input } from 'antd';
import { Button } from 'components/atoms';

interface CheckInputModalProps {
  visible: boolean;
  title: string;
  memo: string;
  onCancel?: (isOk) => void;
  onOk: (isOk, memo) => void;
}

const CheckInputModal = ({
  visible,
  title, 
  memo,
  onCancel,
  onOk,
}: CheckInputModalProps): React.ReactElement => {

  const [memoText, setMemoText] = useState<string>(memo);  

  /* ======================================================
   * methods
   * ====================================================== */
  const getButtons = () => (
    <div className="text-center">
      <Button
        type="primary"
        onClick={() => onOk(true, memoText)}
      >
        확인
      </Button>
      {onCancel && (<Button onClick={() => onCancel(false)}>취소</Button>)}
    </div>
  );


  useEffect(() => {
    setMemoText(memo);
  }, [memo])    

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Modal title={title} open={visible} footer={getButtons()} onCancel={onCancel} centered>
      <Input type="text" placeholder='반려 사유를 입력하세요.' value={memoText} onChange={(e)=>setMemoText(e.target.value)}/>
    </Modal>
  );
};

export default CheckInputModal;
